export const selectCourse = state => state.course;

export const selectOpenDate = state => state.course.openDate;
